import type { LocalCartItem } from '../store/localCartSlice';

const STORAGE_KEY = 'nb_embed_cart';
const TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

interface StorageEntry {
  items: LocalCartItem[];
  expiresAt: number;
}

export function saveCartToStorage(items: LocalCartItem[]): void {
  try {
    const entry: StorageEntry = {
      items,
      expiresAt: Date.now() + TTL_MS
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entry));
  } catch {
    // localStorage may be unavailable (e.g. private browsing, sandboxed iframe)
  }
}

export function loadCartFromStorage(): LocalCartItem[] | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;

    const entry = JSON.parse(raw) as StorageEntry;
    if (Date.now() > entry.expiresAt) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }

    return entry.items;
  } catch {
    return null;
  }
}

export function clearCartFromStorage(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
